import React, {PropsWithChildren, FC} from "react";
import cn from 'classnames'

import styles from "./FilterWrapper.module.scss";

type TFilterWrapperProps = PropsWithChildren & {
  className?: string
}

const FilterWrapper: FC<TFilterWrapperProps> = ({children, className}) => {
  return (
    <div className={cn(styles.filter_wrapper, className)}>
      {children}
    </div>
  );
};

export default FilterWrapper;
